import React, { useState } from 'react';
import { Container, Button, Modal, Form } from 'react-bootstrap';
import { apiFetch } from '../../utils/api';

export default function ConsultationBlock() {
  const [showForm, setShowForm] = useState(false);
  const [firstName, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // Баг L-02: защита от двойного клика

  const handleCloseForm = () => setShowForm(false);
  const handleShowForm = () => setShowForm(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const res = await apiFetch('/api/send-mail', {
        method: "POST",
        body: JSON.stringify({ name: firstName, phone })
      });

      if (res.status === 422) {
        alert("Ошибка: В номере телефона должны быть только цифры и символы +, -, ().");
        setIsSubmitting(false);
        return;
      }

      if (res.status === 429) {
        alert("Вы отправляете заявки слишком часто. Подождите немного.");
        setIsSubmitting(false);
        return;
      }

      if (res.ok) {
        alert("Заявка отправлена! Мы скоро свяжемся с вами.");
        handleCloseForm();
        setName(""); setPhone("");
      } else {
        alert("Произошла ошибка при отправке.");
      }
    } catch (err) {
      alert("Ошибка сети");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="section-cta-refined">
        <Container>
          <div className="bg-white p-5 rounded-3 shadow-sm border text-center mx-auto" style={{ maxWidth: '900px' }}>
            <h3 className="fw-bold mb-3 text-uppercase">Обсудим ваш проект?</h3>
            <p className="text-muted fs-5 mb-4 mx-auto" style={{ maxWidth: '600px' }}>
                Оставьте заявку на бесплатный выезд специалиста и расчет сметы. Мы перезвоним в течение 15 минут.
            </p>
            <Button className="btn-corp px-5 py-3 shadow-sm text-uppercase fw-bold" onClick={handleShowForm}>
              Получить консультацию
            </Button>
          </div>
        </Container>
      </section>

      <Modal show={showForm} onHide={handleCloseForm} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold fs-4 text-uppercase">Заявка на расчет</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted text-uppercase">Как вас зовут?</Form.Label>
              <Form.Control 
                className="bg-light border-0 py-3 shadow-none" 
                placeholder="Имя" 
                value={firstName} 
                onChange={e => setName(e.target.value)} 
                required 
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="small fw-bold text-muted text-uppercase">Ваш номер телефона</Form.Label>
              <Form.Control 
                className="bg-light border-0 py-3 shadow-none" 
                placeholder="+7 (___) ___-__-__" 
                value={phone} 
                onChange={e => setPhone(e.target.value)} 
                required 
              />
            </Form.Group>
            <Button 
                type='submit' 
                className="btn-corp w-100 py-3 fw-bold shadow-sm" 
                disabled={isSubmitting}
            >
              {isSubmitting ? 'ОТПРАВКА...' : 'ОТПРАВИТЬ ЗАЯВКУ'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
